/**
 * Per ATProto spec (OpenID uses RS256)
 */
export const FALLBACK_ALG = 'ES256'
